import Toolkit from './utils/utils';
import Anim from './utils/doAnim';
let myself = Toolkit.myself;

let hGroups = new Anim($("hGroup.hTitle:not(.datetime)"), myself.slideUpBigIn);
let proList = new Anim($(".pro-list"), myself.slideUpBigIn);

/*=================== 滚动事件 ===================*/
$(window).scroll(() => {

	hGroups.doit();
    proList.doit();

});

// 首次加载触发scroll
$(window).trigger("scroll");


// WEBPACK FOOTER //
// ./js/list2.js